module.exports = __webpack_public_path__ + "img/2005 (4).79852e9c.jpg";